<template>
    <slot />
</template>

<script setup>
    import { computed, ref, watch, watchEffect } from 'vue';

    import { basePaneOptions, usePane, useRafBool } from '@resn/gozer-vue';

    import { usePokeball } from '../../common/Objects/usePokeball';
    import { useSceneObject } from './useSceneObject';
    import { useModelExporter } from '~/composables/useModelExporter';

    const props = defineProps({
        visible: { type: Boolean, default: false },
        object: { type: Object, default: null, required: true },
        layer: { type: Number, default: 0 },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        z: { type: Number, default: 0 },
        s: { type: Number, default: 0.95 },
        rx: { type: Number, default: -0.3 },
        ry: { type: Number, default: 0.3 },
        rz: { type: Number, default: 0.28 },
    });

    const ballColor = ref('#ffda3a');

    const rx = ref(props.rx);
    const ry = ref(props.ry);
    const rz = ref(props.rz);
    const px = ref(props.x);
    const py = ref(props.y);
    const pz = ref(props.z);
    const s = ref(props.s);
    const object = props.object;

    const objectProps = { s, rx, ry, rz, px, py, pz };

    const { mainMaterial, ball } = usePokeball({ object });
    useSceneObject({ object, props, objectProps, name: 'Pokemon' });

    ball.overrideProps = {
        roughness: 0.2,
        metalness: 0.7,
    };

    watchEffect(() => {
        mainMaterial.color.set(ballColor.value);
        // boltMaterial.color.set(ballColor.value);
    });

    const modelExport = useModelExporter();

    if (!modelExport) {
        // usePane(
        //     [
        //         { name: 'ballColor', value: ballColor },
        //         { name: 'px', value: px, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'py', value: py, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'pz', value: pz, options: { min: -4, max: 1, step: 0.01 } },
        //         { name: 's', value: s, options: basePaneOptions },
        //         { name: 'rx', value: rx, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'ry', value: ry, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'rz', value: rz, options: { min: -1, max: 1, step: 0.01 } },
        //     ],
        //     { title: 'Pokeball', expanded: false }
        // );
    }
</script>
